import styled, { css } from 'styled-components';
import Button from '@CS/components/Button/Button.styles';
import { BUTTON_WIDTH } from '@CS/components/Popups/Leaderboard/weeks';

type WeekButtonAttributes = {
  selected?: boolean;
};

export default styled(Button)<WeekButtonAttributes>(
  ({ selected }) => css`
    &&& {
      background-color: rgb(255 255 255);
      min-width: ${BUTTON_WIDTH}px;
      width: ${BUTTON_WIDTH}px;

      line-height: 1.625rem;
      border-radius: 15px;
      font-size: 0.75rem;
      color: rgb(0 0 0);

      height: 30px;
      padding: 0;

      ${selected &&
      css`
        background-color: rgb(34 34 34);
        color: rgb(255 255 255);
      `}

      &:active {
        background-color: rgb(34 34 34);
        transform: revert;
      }
    }
  `
);
